import { SiInstagram, SiTiktok, SiYoutube } from '@icons-pack/react-simple-icons';

interface PlatformIconProps {
  /** Platform key, case-insensitive (e.g. 'instagram', 'tiktok', 'youtube'). */
  platform: string;
  size?: number;
  /**
   * Drop the embedded `<title>` when the surrounding text already names the
   * platform. The title is part of the SVG's text content, so next to a
   * "TikTok" label it would otherwise be read — and matched — twice.
   */
  decorative?: boolean;
}

/**
 * Brand glyph for a social platform, rendered in `currentColor` (no brand fill,
 * so it inherits the surrounding text colour). Returns null for an unknown
 * platform. Single source for the platform icon mapping reused across the app.
 */
export function PlatformIcon({ platform, size = 14, decorative = false }: PlatformIconProps) {
  const a11y = decorative ? { 'aria-hidden': true } : undefined;

  switch (platform.toLowerCase()) {
    case 'instagram':
      return <SiInstagram size={size} title={decorative ? '' : 'Instagram'} {...a11y} />;
    case 'tiktok':
      return <SiTiktok size={size} title={decorative ? '' : 'TikTok'} {...a11y} />;
    case 'youtube':
      return <SiYoutube size={size} title={decorative ? '' : 'YouTube'} {...a11y} />;
    default:
      return null;
  }
}

export default PlatformIcon;
